export default __webpack_public_path__ + "static/media/twomaidslogo.b9ae4190.svg";